import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { useEffect } from "react";

export default function UIToggleButton({
  selected,
  handleChange,
  options = [],
  name = "",
  ...rest
}) {
  const setSelectedStyle = (value, opt) => {
    return {
      background:
        selected === value
          ? "var(--palette-primary_button) !important"
          : "var(--palette-grid_table)",
      color:
        selected === value
          ? "var(--palette-primary_button_text) !important"
          : "var(--palette-text)",
      ...opt.sx,
    };
  };

  useEffect(() => {
    if (!selected && options.length > 0) {
      handleChange(null, options[0].value);
    }
  }, [selected, options, handleChange]);

  const onToggleChange = (event, newValue) => {
    if (newValue !== null) {
      handleChange(event, newValue);
    }
  };

  return (
    <ToggleButtonGroup
      value={selected}
      exclusive
      onChange={onToggleChange}
      {...rest}
    >
      {options.map((opt, index) => (
        <ToggleButton
          key={index}
          value={opt.value}
          name={name}
          sx={setSelectedStyle(opt.value, opt)}
        >
          {opt.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
